import React, { useEffect, useImperativeHandle, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextField, Checkbox, FormControlLabel } from "@mui/material";
import "./DataTagFileSearch.scss";
import { FETCH_DATA_TAG_FILES } from "../DataTagConstants";

const DataTagFileSearch = forwardRef(
  ({ value = [], onChange }, ref) => {
    const dispatch = useDispatch();
    const filesList = useSelector(
      (state) => state.dataTagReducer.searchedListFiles
    );

    const [search, setSearch] = React.useState("");

    useEffect(() => {
      dispatch({
        type: FETCH_DATA_TAG_FILES,
        payload: { fileName: search },
      });
    }, [search, dispatch]);

    const toggleSelected = (name) => {
      const updated = value.includes(name)
        ? value.filter((x) => x !== name)
        : [...value, name];

      onChange(updated);
    };

    useImperativeHandle(ref, () => ({
      clear: () => onChange([]),
      apply: () => value,
    }));

    return (
      <div className="data-tag-file-search-container">
        <TextField
          size="small"
          placeholder="Search files..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          fullWidth
          className="search-input"
        />

        <div className="data-tag-file-list">
          {filesList?.length > 0 ? (
            filesList.map((name) => (
              <FormControlLabel
                key={name}
                className="file-item"
                control={
                  <Checkbox
                    size="small"
                    checked={value.includes(name)}
                    onChange={() => toggleSelected(name)}
                  />
                }
                label={name}
              />
            ))
          ) : (
            <p className="no-data">No files found</p>
          )}
        </div>
      </div>
    );
  }
);

export default DataTagFileSearch;
